export { Hash as default } from './Hash';
